export default function getMarketingMessage(){
  const dmnBookingElement = document.querySelector('#youngs-dmn-booking');

  if(dmnBookingElement.dataset.marketingText){
    return dmnBookingElement.dataset.marketingText;
  }

  return `Sign me up for offers, news and promotions, mainly via email`
}
